module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABHNCSVQICAgIfAhkiAAAAOpJREFUeJzt1EEKg1AQREHJyb35ZBkQ1E1MN/lVJxj6wWwbAAAAAAAAfNPM7POxp+9ZymF8EX7pZPyZmUnf9veuxhfgYXfje0EPMn6Q8YOMH2T8IOMHGT/I+EHGDzJ+kPGDjB9k/CDjBxk/yPhBxg8yfpDxg4wfZPwg4wcZP8j4QcYPMn6Y8bftlT6AIC+ogAgFRCggQgERCohQQIQCIhQQoYAIBUQoIEIBEQqIUECEAiIUEKGACAVEKCBCAREKiFBAhAIiFBChgAgF7iKk71vCVYT0bcs4ibCn71rKIcKevgcAAAAAAICHvQFmxPYpYAzVBwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/arrow-left-white.png
// module id = t3vD
// module chunks = 2